module.exports = __webpack_public_path__ + "static/media/user.94e7fa77.svg";